import {
  CheckImageIsFile,
  CheckDataIfExit,
  getLinkPagination,
} from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction, PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetFleet =
  ({ callback, id }) =>
    async (dispatch, getState) => {
      try {
        let link = UrlApi.fleet.get;
        const response = await GetFunction({
          data: {},
          Route: link,
          showalert: false,
          state: getState,
          isMultipart: false,
          dispatch: dispatch,
        });
        console.log({ response })
        callback(response);
      } catch (err) {
        callback(false);
      }
    };

export const ManageFleet =
  ({ callback, values, editMode, id }) =>
    async (dispatch, getState) => {
      try {
        dispatch(setLoading(true));
        var bodyFormData = new FormData();
        if (editMode) {
          bodyFormData.append("id", values?.id);
        }
        if (CheckDataIfExit(values?.type)) {
          bodyFormData.append("type", values?.type?.trim());
        }
        if (CheckDataIfExit(values?.content)) {
          bodyFormData.append("content", values?.content?.trim());
        }
        if (values?.type === 'image') {
          if (CheckDataIfExit(values?.carType)) {
            bodyFormData.append("carType", values?.carType?.trim());
          }
          if (CheckDataIfExit(values?.passengers)) {
            bodyFormData.append("passengers", values?.passengers);
          }
          if (CheckDataIfExit(values?.order_nbr)) {
            bodyFormData.append("order_nbr", values?.order_nbr);
          }
        }

        if (
          values?.image_url &&
          values?.image_url != null &&
          values?.image_url != undefined &&
          CheckImageIsFile({ data: values?.image_url, IsBoolean: true })
        ) {
          bodyFormData.append("image_url", values?.image_url);
        } else if (!values?.image_url) {
          bodyFormData.append("image_url", "");
        }


        const response = await PostFunction({
          data: bodyFormData,
          Route: editMode ? UrlApi.fleet.edit : UrlApi.fleet.add,
          showalert: true,
          state: getState,
          isMultipart: true,
          dispatch: dispatch,
        });
        dispatch(setLoading(false));
        callback(response);
      } catch (err) {
        dispatch(setLoading(false));
        callback(false);
      }
    };


export const EditFleet =
  ({ callback, allData, FleetId, nameFailed, dataFailed }) =>
    async (dispatch, getState) => {
      try {
        dispatch(setLoading(true));
        let data;
        if (allData) {
          data = allData;
        } else {
          data = {
            id: FleetId,
            [nameFailed]: dataFailed,
          };
        }
        const response = await PostFunction({
          data,
          Route: UrlApi.fleet.edit,
          showalert: true,
          state: getState,
          isMultipart: false,
          dispatch: dispatch,
        });
        dispatch(setLoading(false));
        callback(response);
      } catch (err) {
        dispatch(setLoading(false));
        callback(false);
      }
    };

export const DeleteFleet =
  ({ callback, id }) =>
    async (dispatch, getState) => {
      try {
        dispatch(setLoading(true));
        let data = {
          idsFleet: JSON.stringify(id),
        };
        const response = await PostFunction({
          data,
          Route: UrlApi.fleet.delete,
          showalert: true,
          state: getState,
          isMultipart: false,
          dispatch: dispatch,
        });
        dispatch(setLoading(false));
        callback(response);
      } catch (err) {
        dispatch(setLoading(false));
        callback(false);
      }
    };
